export default {
  title_one: 'Utilizare unică, {{discount}}',
  title_few: '{{count}} utilizări, {{discount}}',
  title_other: '{{count}} utilizări, {{discount}}',
  labels: {
    fixed_discount: 'Reducere totală {{discount}}',
    percentage_discount: 'Reducere procentuală',
  },
  buttons: {
    add_component: 'Adaugă utilizare',
  },
};
